import { sv } from "@/i18n/sv";
import { createI18n } from "vue-i18n";

export const i18n = createI18n({
  legacy: false,
  locale: "sv",
  fallbackLocale: "sv",
  availableLocales: ["sv"],
  messages: { sv },
});
